import type from './type.js';
var log = Math.log,
  pow = Math.pow,
  floor = Math.floor,
  abs = Math.abs;
export function analyze(data) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var r = {
    min: Number.MAX_VALUE,
    max: Number.MAX_VALUE * -1,
    sum: 0,
    values: [],
    count: 0
  };
  if (type(data) === 'object') {
    data = Object.values(data);
  }
  data.forEach(function (val) {
    if (key && type(val) === 'object') val = val[key];
    if (val !== undefined && val !== null && !isNaN(val)) {
      r.values.push(val);
      r.sum += val;
      if (val < r.min) r.min = val;
      if (val > r.max) r.max = val;
      r.count += 1;
    }
  });
  r.domain = [r.min, r.max];
  r.limits = function (mode, num) {
    return limits(r, mode, num);
  };
  return r;
}
export function limits(data) {
  var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'equal';
  var num = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 7;
  if (type(data) == 'array') {
    data = analyze(data);
  }
  var _data = data,
    min = _data.min,
    max = _data.max;
  var values = data.values.sort(function (a, b) {
    return a - b;
  });
  if (num === 1) {
    return [min, max];
  }
  var limits = [];
  if (mode.substr(0, 1) === 'c') {
    // continuous
    limits.push(min);
    limits.push(max);
  }
  if (mode.substr(0, 1) === 'e') {
    // equal interval
    limits.push(min);
    for (var i = 1; i < num; i++) {
      limits.push(min + i / num * (max - min));
    }
    limits.push(max);
  } else if (mode.substr(0, 1) === 'l') {
    // log scale
    if (min <= 0) {
      throw new Error('Logarithmic scales are only possible for values > 0');
    }
    var min_log = Math.LOG10E * log(min);
    var max_log = Math.LOG10E * log(max);
    limits.push(min);
    for (var _i = 1; _i < num; _i++) {
      limits.push(pow(10, min_log + _i / num * (max_log - min_log)));
    }
    limits.push(max);
  } else if (mode.substr(0, 1) === 'q') {
    // quantile scale
    limits.push(min);
    for (var _i2 = 1; _i2 < num; _i2++) {
      var p = (values.length - 1) * _i2 / num;
      var pb = floor(p);
      if (pb === p) {
        limits.push(values[pb]);
      } else {
        // p > pb
        var pr = p - pb;
        limits.push(values[pb] * (1 - pr) + values[pb + 1] * pr);
      }
    }
    limits.push(max);
  } else if (mode.substr(0, 1) === 'k') {
    // k-means clustering
    /*
    implementation based on
    http://code.google.com/p/figue/source/browse/trunk/figue.js#336
    simplified for 1-d input values
    */
    var cluster;
    var n = values.length;
    var assignments = new Array(n);
    var clusterSizes = new Array(num);
    var repeat = true;
    var nb_iters = 0;
    var centroids = null;

    // get seed values
    centroids = [];
    centroids.push(min);
    for (var _i3 = 1; _i3 < num; _i3++) {
      centroids.push(min + _i3 / num * (max - min));
    }
    centroids.push(max);
    while (repeat) {
      // assignment step
      for (var j = 0; j < num; j++) {
        clusterSizes[j] = 0;
      }
      for (var _i4 = 0; _i4 < n; _i4++) {
        var value = values[_i4];
        var mindist = Number.MAX_VALUE;
        var best = void 0;
        for (var _j = 0; _j < num; _j++) {
          var dist = abs(centroids[_j] - value);
          if (dist < mindist) {
            mindist = dist;
            best = _j;
          }
          clusterSizes[best]++;
          assignments[_i4] = best;
        }
      }

      // update centroids step
      var newCentroids = new Array(num);
      for (var _j2 = 0; _j2 < num; _j2++) {
        newCentroids[_j2] = null;
      }
      for (var _i5 = 0; _i5 < n; _i5++) {
        cluster = assignments[_i5];
        if (newCentroids[cluster] === null) {
          newCentroids[cluster] = values[_i5];
        } else {
          newCentroids[cluster] += values[_i5];
        }
      }
      for (var _j3 = 0; _j3 < num; _j3++) {
        newCentroids[_j3] *= 1 / clusterSizes[_j3];
      }

      // check convergence
      repeat = false;
      for (var _j4 = 0; _j4 < num; _j4++) {
        if (newCentroids[_j4] !== centroids[_j4]) {
          repeat = true;
          break;
        }
      }
      centroids = newCentroids;
      nb_iters++;
      if (nb_iters > 200) {
        repeat = false;
      }
    }

    // finished k-means clustering
    // the next part is borrowed from gabrielflor.it
    var kClusters = {};
    for (var _j5 = 0; _j5 < num; _j5++) {
      kClusters[_j5] = [];
    }
    for (var _i6 = 0; _i6 < n; _i6++) {
      cluster = assignments[_i6];
      kClusters[cluster].push(values[_i6]);
    }
    var tmpKMeansBreaks = [];
    for (var _j6 = 0; _j6 < num; _j6++) {
      tmpKMeansBreaks.push(kClusters[_j6][0]);
      tmpKMeansBreaks.push(kClusters[_j6][kClusters[_j6].length - 1]);
    }
    tmpKMeansBreaks = tmpKMeansBreaks.sort(function (a, b) {
      return a - b;
    });
    limits.push(tmpKMeansBreaks[0]);
    for (var _i7 = 1; _i7 < tmpKMeansBreaks.length; _i7 += 2) {
      var v = tmpKMeansBreaks[_i7];
      if (!isNaN(v) && limits.indexOf(v) === -1) {
        limits.push(v);
      }
    }
  }
  return limits;
}